const ticketSelectedFilters = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_TICKET_SELECTED_FILTERS':
            return action.ticketSelectedFilters
        default:
            return state
    }
}

export default ticketSelectedFilters;